module.exports = __webpack_public_path__ + "static/media/Solefish.318f6e31.png";